import React, { useRef } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import RbCarousel from "react-bootstrap-carousel";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";


function Welcome() {
    let history = useHistory();
    const slide = useRef(null);

    function goTo(params){
        console.log(params);
        slide.current.goToSlide(params);
    }

    return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/welcome.css'}]
	}/>

    <div className="row no-gutters">
      <div className="bg-grey application">
        <div className="container-fluid px-0">
            <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
                <ol className="carousel-indicators">
                    <li data-target="#carouselExampleControls" data-slide-to="0" className="active"></li>
                    <li data-target="#carouselExampleControls" data-slide-to="1"></li>
                    <li data-target="#carouselExampleControls" data-slide-to="2"></li>
                </ol>
                <div className="carousel-inner" role="listbox">
                    <div className="carousel-item active bkb">
                        <div className="appHeader bg-transparent text-light position-relative">
                            <div className="left">
                                <a className="headerButton" onClick={() => history.goBack()}>
                                    <img src={require("./../images/faq-icon.png").default} alt="back" className="img-fluid" />
                                </a>
                            </div>
                            <div className="pageTitle">&nbsp;</div>
                            <div className="right">
                                <Link to="/home" className="headerButton skip">
                                    Skip
                                </Link>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center min-vh-100">
                            <img src={require("./../images/slider-bkb.png").default} alt="slider bkb" className="img-fluid img-slider-bkb" />
                            <div className="slider-content">
                                <div className="px-3 py-5">
                                    <p className="my-3 slider-title">Welcome to <span className="slider-title-red">BKB</span></p>
                                    <p className="mb-3 slider-details">A first of it’s kind competition for <br /> Pay1 distributors to compete and <br /> earn amazing rewards.</p>
                                    <div className="carousel-button-footer">
                                        <div className="row">
                                            <div className="col-6">
                                                <Link to="/faq/BKB" className="btn btn-purple">
                                                    Learn More
                                                </Link>
                                            </div>
                                            <div className="col-6">
                                                <a className="btn btn-red float-right width-80" href="#carouselExampleControls" role="button" data-slide="next"><img src={require("./../images/right-white.png").default} alt="right-white" className="img-fluid" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item bkb">
                        <div className="appHeader bg-transparent text-light position-relative">
                            <div className="left">
                                <a className="headerButton" onClick={() => history.goBack()}>
                                    <img src={require("./../images/faq-icon.png").default} alt="back" className="img-fluid" />
                                </a>
                            </div>
                            <div className="pageTitle">&nbsp;</div>
                            <div className="right">
                                <Link to="/home" className="headerButton skip">
                                    Skip
                                </Link>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center min-vh-100">
                            <img src={require("./../images/slider-kingdom.png").default} alt="slider bkb" className="img-fluid img-slider-kingdom" />
                            <div className="slider-content">
                                <div className="px-3 py-5">
                                    <p className="my-3 slider-title">KINGDOMS</p>
                                    <p className="mb-3 slider-details">Where you and members of your <br/> kingdom help each other, work together, <br/> and play together.</p>
                                    <div className="carousel-button-footer">
                                        <div className="row">
                                            <div className="col-6">
                                                <Link to="/faq/Kingdoms" className="btn btn-purple">
                                                    Learn More
                                                </Link>
                                            </div>
                                            <div className="col-6">
                                                <a className="btn btn-red float-right width-80" href="#carouselExampleControls" role="button" data-slide="next"><img src={require("./../images/right-white.png").default} alt="right-white" className="img-fluid" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item bkb">
                        <div className="appHeader bg-transparent text-light position-relative">
                            <div className="left">
                                <a className="headerButton" onClick={() => history.goBack()}>
                                    <img src={require("./../images/faq-icon.png").default} alt="back" className="img-fluid" />
                                </a>
                            </div>
                            <div className="pageTitle">&nbsp;</div>
                            <div className="right">
                                <Link to="/home" className="headerButton skip">
                                    Skip
                                </Link>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center min-vh-100">
                            <img src={require("./../images/slider-war.png").default} alt="slider bkb" className="img-fluid img-slider-war" />
                            <div className="slider-content">
                                <div className="px-3 py-5">
                                    <p className="my-3 slider-title">Go to <span className="slider-title-red">WAR</span></p>
                                    <p className="mb-3 slider-details">Battle other Kingdoms to increase <br/> wealth and acquire points inorder to <br/> compete against Kingdoms.</p>
                                    <div className="carousel-button-footer">
                                        <div className="row position-relative" >
                                            <div className="col-6">
                                                <Link to="/faq/War" className="btn btn-purple">
                                                    Learn More
                                                </Link>
                                            </div>
                                            <div className="col-6">
                                                <Link to="/home">
                                                    <div className="btn btn-red float-right" >Get Started</div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div className="bg"></div>
    </div>


    {/* <div classNameName="row no-gutters h-100 bg">
      <div classNameName="bg-grey application">
        <div classNameName="container-fluid px-0">
            <div id="carouselExampleControls" classNameName="carousel slide" data-ride="carousel">
                <div role="listbox">
                    <div classNameName="appHeader bg-transparent text-light" style={{zIndex: `+15`}}>
                        <div classNameName="left">
                            <a classNameName="headerButton" onClick={() => history.goBack()} >
                                <img src={require("./../images/faq-icon.png").default} alt="back" classNameName="img-fluid" />
                            </a>
                        </div>
                        <div classNameName="pageTitle">&nbsp;</div>
                        <div classNameName="right">
                            <Link to="/home">
                                <div classNameName="headerButton skip">
                                    Skip
                                </div>
                            </Link>
                        </div>
                    </div>
                    <RbCarousel 
                        animation={true}
                        autoplay="start"
                        slideshowSpeed={2000000}
                        version={4}
                        defaultActiveIndex={0}
                        // leftIcon=""
                        // rightIcon="" 
                        ref={slide}
                    >
                        <div>
                        <div classNameName="d-flex align-items-center justify-content-center min-vh-100 carousel-item " >
                            
                            <img src={require("./../images/slider-bkb.png").default} alt="slider bkb" classNameName="img-fluid img-slider-bkb" />
                            <div classNameName=" slider-content">
                                <div classNameName="px-3 py-5">
                                    <p classNameName="my-3 slider-title">Welcome to <span classNameName="slider-title-red">BKB</span></p>
                                    <p classNameName="mb-3 slider-details">A first of it’s kind competition for <br /> Pay1 distributors to compete and <br /> earn amazing rewards.</p>
                                    <div classNameName="carousel-button-footer">
                                        <div classNameName="row">
                                            <div classNameName="col-6">
                                                <Link to="/faq/BKB">
                                                    <div classNameName="btn btn-purple">Learn More</div>
                                                </Link>
                                            </div>
                                            <div classNameName="col-6" onClick={() => goTo(1)}>
                                                <a classNameName="btn btn-red float-right width-80" role="button" data-slide="next"><img src={require("./../images/right-white.png").default} alt="right-white" classNameName="img-fluid" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>


                        <div>
                        <div classNameName="d-flex align-items-center justify-content-center min-vh-100 carousel-item ">
                            <img src={require("./../images/slider-kingdom.png").default} alt="slider bkb" classNameName="img-fluid img-slider-kingdom" />
                            <div classNameName="slider-content">
                                <div classNameName="px-3 py-5">
                                    <p classNameName="my-3 slider-title">KINGDOMS</p>
                                    <p classNameName="mb-3 slider-details">Where you and members of your <br/> kingdom help each other, work together, <br/> and play together.</p>
                                    <div classNameName="carousel-button-footer">
                                        <div classNameName="row">
                                            <div classNameName="col-6">
                                                <Link to="/faq/Kingdoms">
                                                    <div classNameName="btn btn-purple">Learn More</div>
                                                </Link>
                                            </div>
                                            <div classNameName="col-6" onClick={() => goTo(2)}>
                                                <a classNameName="btn btn-red float-right width-80" role="button" data-slide="next"><img src={require("./../images/right-white.png").default} alt="right-white" classNameName="img-fluid" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        
                        <div classNameName="d-flex align-items-center justify-content-center min-vh-100">
                            <img src={require("./../images/slider-war.png").default} alt="slider bkb" classNameName="img-fluid img-slider-war" />
                            <div classNameName="slider-content">
                                <div classNameName="px-3 py-5">
                                    <p classNameName="my-3 slider-title">Go to <span classNameName="slider-title-red">WAR</span></p>
                                    <p classNameName="mb-3 slider-details">Battle other Kingdoms to increase <br/> wealth and acquire points inorder to <br/> compete against Kingdoms.</p>
                                    <div classNameName="carousel-button-footer">
                                        <div classNameName="row">
                                            <div classNameName="col-6">
                                                <Link to="/faq/War">
                                                    <div classNameName="btn btn-purple">Learn More</div>
                                                </Link>
                                            </div>
                                            <div classNameName="col-6">
                                                <Link to="/home">
                                                    <div classNameName="btn btn-red float-right" >Get Started</div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </RbCarousel>
                </div>
            </div>
        </div>
      </div>
    </div> */}
</>
    );
}

export default Welcome;
